export default __webpack_public_path__ + "static/media/icon_arrow_down.86cc664d.svg";